import { Divider, Text } from "@vericus/cadmus-ui";

import { UserFragment } from "@/generated/graphql";

import { DateRange } from "../types";
import * as styles from "./activity-charts.css";
import { PasteRatioChart } from "./paste-ratio-chart";
import { WordCountChart } from "./word-count-chart";

interface ActivityReportProps {
  // Assessment ID
  assessmentId: string;
  // Work ID
  workId: string;
  // Callback to update date ranges
  setSelectedDateRange: (dateRange: DateRange) => void;
  // Selected date range
  selectedDateRange: DateRange;
  // Members of the group
  members: UserFragment[];
}

/**
 * Activity Report component
 *
 * This component is used to display the activity report for a given date range.
 * It displays a word count chart and a date range filter.
 *
 * This will contain 2 tabs:
 * 1. Word Count - Displays a word count chart
 * 2. Paste Ratio - Displays a paste ratio chart (TBD)
 * 3. Sessions - Displays a sessions chart (TBD)
 * 4. Citations - Displays a citations chart (TBD)
 *
 * It is used in the GroupInsightsPage components.
 */
export function ActivityCharts(props: ActivityReportProps) {
  return (
    <>
      <div className={styles.chartContainer}>
        <Text kind="headingSix">Word Count</Text>
        <Divider style={{ marginBottom: 12, marginTop: 12 }} />
        <WordCountChart {...props} />
      </div>
      <div className={styles.chartContainer}>
        <Text kind="headingSix">Paste Ratio</Text>
        <Divider style={{ marginBottom: 12, marginTop: 12 }} />
        <PasteRatioChart {...props} />
      </div>
    </>
  );
}
